/**
 * 🚨🚨🚨 DO NOT ADD ANY NEW TOKENS WITHOUT CONSULTING THE DESIGN TEAM 🚨🚨🚨
 */
export enum TextDescriptionVariant {
  // Primary Fonts (Archivo)
  TEXT_2XS_REGULAR = '2XS regular text',
  TEXT_2XS_SEMIBOLD = '2XS semi bold text',
  TEXT_2XS_SEMIBOLD_ITALIC = '2XS semi bold italic text',
  TEXT_2XS_XBOLD = '2XS extra bold text',
  TEXT_2XS_XBOLD_ITALIC = '2XS extra bold italic text',

  TEXT_XS_REGULAR = 'XS regular text',
  TEXT_XS_REGULAR_ITALIC = 'XS regular italic text',
  TEXT_XS_SEMIBOLD = 'XS semi bold text',
  TEXT_XS_SEMIBOLD_ITALIC = 'XS semi bold italic text',
  TEXT_XS_BOLD = 'XS bold text',
  TEXT_XS_BOLD_ITALIC = 'XS bold italic text',

  TEXT_SMALL_REGULAR = 'Small regular text',
  TEXT_SMALL_SEMIBOLD = 'Small semi bold text',
  TEXT_SMALL_BOLD = 'Small bold text',
  TEXT_SMALL_XBOLD = 'Small extra bold text',

  TEXT_BASE_REGULAR = 'Base regular text',
  TEXT_BASE_SEMIBOLD = 'Base semi bold text',
  TEXT_BASE_BOLD = 'Base bold text',
  TEXT_BASE_BOLD_ITALIC = 'Base bold italic text',
  TEXT_BASE_XBOLD = 'Base extra bold text',
  TEXT_BASE_BLACK = 'Base black text',

  TEXT_BODY_REGULAR = 'Body regular text',
  TEXT_BODY_REGULAR_ITALIC = 'Body regular italic text',
  TEXT_BODY_BOLD = 'Body bold text',
  TEXT_BODY_BOLD_ITALIC = 'Body bold italic text',

  TEXT_MD_REGULAR = 'Medium regular text',
  TEXT_MD_SEMIBOLD = 'Medium semi bold text',
  TEXT_MD_XBOLD = 'Medium extra bold text',
  TEXT_MD_BLACK = 'Medium black text',

  TEXT_LG_REGULAR = 'Large regular text',
  TEXT_LG_BOLD = 'Large bold text',
  TEXT_LG_BOLD_ITALIC = 'Large bold italic text',
  TEXT_LG_BLACK = 'Large black text',

  TEXT_XL_XBOLD = 'XL extra bold text',
  TEXT_XL_BLACK = 'XL black text',

  TEXT_2XL_REGULAR = '2XL regular text',
  TEXT_2XL_BOLD = '2XL bold text',
  TEXT_2XL_BLACK = '2XL black text',

  TEXT_3XL_XBOLD = '3XL extra bold text',
  TEXT_3XL_BLACK = '3XL black text',

  TEXT_4XL_REGULAR = '4XL regular text',
  TEXT_4XL_BLACK = '4XL black text',

  TEXT_5XL_XBOLD = '5XL extra bold text',
  TEXT_5XL_BLACK = '5XL black text',

  // Secondary Fonts (Archivo Narrow)
  TEXT_2XS_NARROW_REGULAR = 'Narrow 2XS regular text',
  TEXT_2XS_NARROW_BOLD = 'Narrow 2XS bold text',

  TEXT_XS_NARROW_REGULAR = 'Narrow XS regular text',
  TEXT_XS_NARROW_SEMIBOLD = 'Narrow XS semi bold text',
  TEXT_XS_NARROW_BOLD = 'Narrow XS bold text',

  TEXT_SMALL_NARROW_REGULAR = 'Narrow Small regular text',
  TEXT_SMALL_NARROW_BOLD = 'Narrow Small bold text',

  TEXT_BASE_NARROW_REGULAR = 'Narrow Base regular text',
  TEXT_BASE_NARROW_BOLD = 'Narrow Base bold text',
}
